import Repository from '../../repositories/RepositoryFactory';
const inventoryItemCatalogs = Repository.get('inventoryItemCatalogs');

export default {
	namespaced: true,
	state: {
		itemCatalogs: [],
		selectedItemCatalog: {},
		itemCategoryOptions: [],
	},
	mutations: {
		SET_ITEM_CATALOGS (state, payload) {
			state.itemCatalogs = payload;
		},
		SET_ITEM_CATALOG (state, payload) {
			state.selectedItemCatalog = payload;
		},
		SET_ITEM_CATEGORY_OPTIONS (state, payload) {
			state.itemCategoryOptions = payload;
		},
		DELETE_ITEM_CATALOG (state, id) {
			state.itemCatalogs = state.itemCatalogs.filter((catalog) => catalog.id !== id);
			if (state.selectedItemCatalog.id === id) {
				state.selectedItemCatalog = {};
			}
		},
	},
	actions: {
		async getItemCatalogs ({ commit }) {
			commit('SET_ITEM_CATALOGS', await inventoryItemCatalogs.getItemCatalogs());
		},
		async getItemCatalogById ({ commit }, id) {
			commit('SET_ITEM_CATALOG', await inventoryItemCatalogs.getItemCatalogById(id));
		},
		async getInventoryItemCategoryOptions ({ commit }) {
			commit('SET_ITEM_CATEGORY_OPTIONS', await inventoryItemCatalogs.getInventoryItemCategoryOptions());
		},
		async addItemCatalog ({ commit }, body) {
			await inventoryItemCatalogs.addItemCatalog(body);
		},
		async editItemCatalog ({ commit }, body) {
			await inventoryItemCatalogs.editItemCatalog(body);
		},
		async deleteItemCatalog ({ commit }, id) {
			await inventoryItemCatalogs.deleteItemCatalog(id);
			commit('DELETE_ITEM_CATALOG', id);
		},
	},
};
